export const DISPLAYED_LICENSES_LIMIT = 4;
